export const branchesListId = 'branches-list-section';
